import { Backdrop } from '@mui/material';
import { Loader } from '@care/react-component-lib';
import { ExternalVendors } from '@/__generated__/globalTypes';
import { Redirecting } from './components/Redirecting';

export type RedirectingTo = 'internal' | ExternalVendors | null;

export interface RedirectingBackdropProps {
  to?: RedirectingTo;
}

export const RedirectingBackdrop = ({ to }: RedirectingBackdropProps) => {
  const isRedirecting = Boolean(to);

  return (
    <Backdrop
      open={isRedirecting}
      sx={({ palette }) => ({
        zIndex: 2000,
        backgroundColor: `${palette.common.white} !important`,
        p: 3,
      })}>
      {to === 'internal' && <Loader data-testid="overlay-loader" />}
      {!!to && to !== 'internal' && <Redirecting provider={to} />}
    </Backdrop>
  );
};
